import { Mail, Trash2, Building2, Globe2, Briefcase } from "lucide-react";
import { serviceDisplayName } from "@/lib/serviceNames";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";

export const STATUSES = ["new", "contacted", "closed"];
export const STATUS_STYLE = {
  new: "bg-[#D4AF37] text-[#082F24]",
  contacted: "bg-[#E8F3EE] text-[#0F5A47]",
  closed: "bg-stone-200 text-stone-700",
};

export const fmtDate = (iso) => new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });

const Meta = ({ icon: Icon, children }) => (
  <p className="flex items-center gap-2 text-sm text-[#52635B]"><Icon className="h-4 w-4 text-[#0F5A47]" />{children || "-"}</p>
);

export const EnquiryDetail = ({ e, onStatus, onDelete }) => (
  <div data-testid="enquiry-detail" className="rounded-3xl bg-white border border-[#0F5A47]/12 p-6 sm:p-8">
    <p className="font-mono-ega text-xs text-[#52635B]">{fmtDate(e.created_at)}</p>
    <h2 className="mt-2 font-display text-4xl text-[#082F24] break-words">{e.name}</h2>
    <a href={`mailto:${e.email}`} data-testid="enquiry-detail-email" className="mt-1 inline-flex items-center gap-2 text-[#0F5A47] underline break-all"><Mail className="h-4 w-4" />{e.email}</a>
    <div className="mt-6 grid gap-2 sm:grid-cols-3">
      <Meta icon={Building2}>{e.company}</Meta>
      <Meta icon={Globe2}>{e.country}</Meta>
      <Meta icon={Briefcase}>{serviceDisplayName(e.service_interest)}</Meta>
    </div>
    <p data-testid="enquiry-detail-message" className="mt-6 rounded-2xl bg-[#FAF8F5] p-5 text-[#1A2520] whitespace-pre-wrap leading-relaxed">{e.message}</p>
    <div className="mt-6 flex flex-wrap items-center gap-2">
      {STATUSES.map((s) => (
        <button key={s} data-testid={`enquiry-status-${s}-btn`} onClick={() => onStatus(e.id, s)} className={`rounded-full px-4 py-2 text-sm capitalize transition-colors ${e.status === s ? STATUS_STYLE[s] + " font-semibold" : "border border-[#0F5A47]/20 text-[#52635B] hover:bg-[#FAF8F5]"}`}>{s}</button>
      ))}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button data-testid="enquiry-delete-btn" className="ml-auto inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm text-red-700 hover:bg-red-50"><Trash2 className="h-4 w-4" />Delete</button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete this enquiry?</AlertDialogTitle>
            <AlertDialogDescription>The enquiry from {e.name} will be permanently removed.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="enquiry-delete-cancel-btn">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="enquiry-delete-confirm-btn" onClick={() => onDelete(e.id)} className="bg-red-700 hover:bg-red-800">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  </div>
);
